(ns manage.variants-preview-panel.view.core
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Popover$default" :as Popover]
            ["@mui/material/Skeleton$default" :as Skeleton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["react" :as react]
            ["src/svg/artwork/error.svg$default" :as Error]
            [cljs-bean.core :refer [->clj]]
            [common.display-tag :refer [display-tag]]
            [common.flags :refer [use-flag]]
            [common.util :refer [spread-obj]]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.iframe.view :as iframe]
            [common.widgets.input :refer [input]]
            [common.widgets.template-preview :refer [no-preview-possible]]
            [goog.crypt.base64 :as base64]
            [manage.ad-variant.widgets :as variant-widgets]
            [manage.variants-preview-panel.view.sidebar :refer [sidebar]]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui approval-button [{:keys [variant-id approved? published?]}]
  (let [[anchor set-anchor] (react/useState nil)
        button-text (cond
                      (= published? "unpublished") "Unpublished"
                      published? "Published"
                      approved? "Approved"
                      :else "Draft")
        color (cond
                published? "#112847"
                approved? "#226E4E"
                :else "#112847")
        background-color (cond
                           published? "#F0F2F4"
                           approved? "#DFFFEF"
                           :else "#F0F2F4")]
    ($ :<>
       ($ Button
          (cond-> {:onClick (fn [e]
                              (set-anchor (.-currentTarget e)))
                   :variant "contained"
                   :sx (spread-obj #js {:width "fit-content"
                                        :padding "2px 8px"
                                        :textTransform "uppercase"
                                        :fontSize "1.2rem"
                                        :borderRadius "2px"
                                        :boxShadow "none"
                                        :color color
                                        :backgroundColor background-color
                                        "&:hover" {:backgroundColor background-color}}
                                   (when published?
                                     #js {:pointerEvents "none"}))}
            (not published?) (assoc :endIcon ($ Icon "arrow_drop_down")))
          button-text)
       (when-not published?
         ($ Popover
            {:anchorEl anchor
             :open (boolean anchor)
             :onClose #(set-anchor nil)
             :anchorOrigin #js {:vertical "bottom"
                                :horizontal "left"}}
            ($ Stack {:spacing 0 :width "min-content"}
               ($ MenuItem
                  {:onClick #(do
                               (rf/dispatch [:variants-preview.variants/approve-variant variant-id])
                               (set-anchor nil))
                   :sx #js {:padding "10px 18px"}}
                  ($ :<>
                     ($ Icon {:sx #js {:margin "0 8px 0 0"}}
                        (if approved? "checkmark" ""))
                     "Approved"))
               ($ MenuItem
                  {:onClick #(do
                               (rf/dispatch [:variants-preview.variants/unapprove-variant variant-id])
                               (set-anchor nil))
                   :sx #js {:padding "10px 18px"}}
                  ($ :<>
                     ($ Icon {:sx #js {:margin "0 8px 0 0"}}
                        (if-not approved? "checkmark" ""))
                     "Draft"))))))))

(defui login-button []
  ($ Button
     {:href (r.easy/href :common/login {} {:from (str js/window.location.href)})
      :variant "contained"
      :sx #js {:width "fit-content"
               :padding "2px 8px"
               :textTransform "uppercase"
               :fontSize "1.2rem"
               :borderRadius "2px"
               :color "#112847"
               :backgroundColor "#F0F2F4"
               "&:hover" {:backgroundColor "#F0F2F4"}}}
     "Login to approve"))

;; TODO: Move to a generic place, ad-variant-preview uses also a version
(defn use-intersection [ref]
  (let [[in-view? set-in-view] (react/useState false)]
    (react/useEffect (fn []
                       (if (some? (.-current ref))
                         (let [handler (fn [entries]
                                         (set-in-view (boolean (some #(.-isIntersecting %) (->clj entries)))))
                               ;; Load the video element a bit before the element becomes visible
                               ;; (rootMargin 25% means the element can be 25% of the height of the container, the page,
                               ;;  away from e.g. top of the page)
                               ;; and consider it visible if even a single pixel is visible (threshold 0)
                               observer (js/IntersectionObserver. handler #js {:root nil :rootMargin "25%" :threshold 0.0})]
                           (.observe observer (.-current ref))
                           (fn []
                             (set-in-view false)
                             (.disconnect observer)))
                         js/undefined))
                     ;; FIXME: This is incorrrect,
                     ;; this won't trigger when the element is available etc.
                     ;; because ref current doesn't trigger render (or effect).
                     #js [(.-current ref)])
    in-view?))

(defui preview-video-render [{:keys [variant-id]}]
  (let [content-id (use-subscribe [:variants-preview.variants/content-id variant-id])
        source (use-subscribe [:variants-preview.variants/url variant-id])
        auto-play (use-subscribe [:variants-preview.core/auto-play])
        auto-mute (use-subscribe [:variants-preview.core/auto-mute])
        width (use-subscribe [:variants-preview.core/video-width])
        height (use-subscribe [:variants-preview.core/video-height])
        state (use-subscribe [:variants-preview.variants/adjacent-call-state])

        auth-status (use-subscribe [:resource.auth/init-status])
        approved? (use-subscribe [:variants-preview.variants/approval-status variant-id])
        published? (use-subscribe [:variants-preview.variants/published-status variant-id])
        width (if (> (int width) 0) (int width) 0)
        height (if (> (int height) 0) (int height) 0)
        channel (use-subscribe [:resource.adset-preview/adset-channel])
        {:keys [score-available score]} (use-subscribe [:variants-preview.variants/createlift-score variant-id])
        create-lift-feature? (use-flag :create-lift-preview)
        intersection-ref (react/useRef nil)
        in-view? (use-intersection intersection-ref)]
    ($ Stack
       {:spacing 1
        :ref intersection-ref
        :sx #js {:width "min-content"}}
       ($ Typography {:font-Weight "600" :sx #js {:wordBreak "break-all"}} content-id)
       (when (not= channel "display")
         ($ Stack {:direction "row"}
            (when (not= auth-status :initializing)
              (if (and (not= auth-status :success) (not published?))
                ($ login-button)
                ($ approval-button
                   {:variant-id variant-id
                    :approved? approved?
                    :published? published?})))
            (if score-available
              ($ variant-widgets/predictive-score-chip
                 {:score score
                  :label (str "Predictive score " score "%")})
              (when create-lift-feature?
                ($ Skeleton
                   {:width "150px"
                    :height "25px"
                    :variant "rectangular"
                    :sx #js {:marginLeft "4px"}})))))
       (if-not in-view?
         ($ Skeleton
            {:variant "rectangular"
             :width width
             :height height})
         (if source
           ($ :video
              {:src source
               :muted auto-mute
               :autoPlay auto-play
               :style #js {:width width
                           :height height}
               :controls true
               :type "video/mp4"})
           (when-not (= state :pending) ($ no-preview-possible {:reason-str "rendering hasn't finished"})))))))

(defui preview-display-tag [{:keys [iframe-ref advertiser-id adset-id
                                    content template width height scale
                                    preview-passthrough preview-token]}]
  (let [lemonpi-env (.-__LEMONPI_ENV__ js/window)
        environment (case lemonpi-env
                      "local" "local"
                      "development" "dev"
                      ("test" "acceptance") "test"
                      "prod")
        config (merge {:version            2
                       :adserver           {:code "lemonpi"}
                       :advertiserId       advertiser-id
                       :adsetId            adset-id
                       :environment        environment}
                      (if preview-passthrough
                        {:staticContent      false
                         :previewPassthrough preview-passthrough
                         :previewToken       preview-token}
                        {:staticContent true
                         :template      template
                         :exportContent content}))
        encoded-config (-> (clj->js config)
                           js/JSON.stringify
                           base64/encodeStringUtf8)
        tag-text (str "<ins width=\"" width "px\" height=\"" height "px\">"
                      "<script "
                      "data-width='" width "' "
                      "data-height='" height "' "
                      "data-lemonpi-config='" encoded-config "'"
                      "src='" (:creativeLibraryUrl (use-subscribe [:config])) "'"
                      ">"
                      "</script>"
                      "</ins>")]
    ($ display-tag
       {:tag-text tag-text :width width :height height :iframe-ref iframe-ref :scale scale})))

(defn- preview-display-render [variant-id render]
  (let [content-id @(rf/subscribe [:variants-preview.variants/content-id variant-id])
        {:keys [job-state advertiser-id adset-id]} render
        {:keys [width height template content]} (-> render :job-result)
        iframe-ref (react/useRef nil)
        intersection-ref (react/useRef nil)

        auth-status @(rf/subscribe [:resource.auth/init-status])
        approved? @(rf/subscribe [:variants-preview.variants/approval-status variant-id])
        published? @(rf/subscribe [:variants-preview.variants/published-status variant-id])
        in-view? (use-intersection intersection-ref)]
    [:> Stack {:spacing 1 :width "min-content" :ref intersection-ref}
     [:> Typography {:font-weight "600" :sx {:word-break "break-all"}} content-id]
     [:> Stack {:direction "row" :align-items "center" :spacing 1
                :sx {:justify-content "space-between"}}
      [:> Stack {:direction "row" :align-items "center" :spacing 1}
       [:> Chip {:label (str width "x" height)}]]
      [:> IconButton {:on-click #(iframe/reload (.-current iframe-ref))} [:> Icon "refresh"]]]
     (when (not= auth-status :initializing)
       (if (and (not= auth-status :success) (not published?))
         ($ login-button)
         ($ approval-button
            {:variant-id variant-id
             :approved? approved?
             :published? published?})))
     (if-not in-view?
       [:> Skeleton {:variant "rectangular"
                     :width width
                     :height height}]
       (case job-state
         "succeeded" ($ preview-display-tag
                        {:iframe-ref iframe-ref
                         :advertiser-id advertiser-id
                         :adset-id adset-id
                         :content content
                         :template template
                         :width width
                         :height height})
         "failed" ($ no-preview-possible {:reason-str "rendering has failed"})
         ($ no-preview-possible {:reason-str "rendering not available yet"})))]))

(defui preview-iframe
  [{:keys [iframe-ref]
    :template/keys [width height url variant-id]}]
  (let [renders (use-subscribe [:variants-preview.variants/renders variant-id])
        content (-> renders
                    first
                    :job-result
                    :content)]
    ($ iframe/iframe-new
       {:src url
        :ref iframe-ref
        :height height
        :width width
        :on-ready (fn [iframe]
                    ;; Sending empty data causes an error, so avoid sending if we have no preview-content.
                    (when content
                      (iframe/post-lemonpi-config iframe content)))
        :style {:border-width 0}})))

(defui external-template-render [{:keys [external-template variant-id]}]
  (let [{:keys [template/width template/height template/name]} external-template
        iframe-ref (uix/use-ref nil)
        intersection-ref (react/useRef nil)
        in-view? (use-intersection intersection-ref)]
    ($ Stack {:direction "column" :align-items "center" :spacing 1 :ref intersection-ref}
       ($ Stack {:direction "row" :align-items "center" :spacing 1}
          ($ Typography {:font-weight "600" :sx #js {:wordBreak "break-all"}} name)
          ($ Chip {:label (str width "x" height)})
          ($ IconButton {:on-click #(iframe/reload @iframe-ref)}
             ($ Icon "refresh")))
       (if-not in-view?
         ($ Skeleton {:variant "rectangular"
                      :width width
                      :height height})
         ($ preview-iframe (assoc external-template
                                  :iframe-ref iframe-ref
                                  :template/variant-id variant-id))))))

(defn- preview-display-renders [variant-id]
  (let [renders @(rf/subscribe [:variants-preview.variants/renders variant-id])
        external-templates @(rf/subscribe [:variants-preview.variants/external-templates])]
    [:> Stack {:direction "row" :flex-wrap "wrap" :gap 3}
     (for [render renders
           :let [template-revision-id (-> render :job-result :template :id)]]
       ^{:key template-revision-id}
       [:f> preview-display-render variant-id render])
     (for [external-template external-templates]
       ($ external-template-render {:key (:template/name external-template)
                                    :variant-id variant-id
                                    :external-template external-template}))]))

(defn- preview-variant [variant-id]
  (let [job-result-type @(rf/subscribe [:variants-preview.variants/job-result-type variant-id])]
    (case job-result-type
      "display-job-result:v0" [:f> preview-display-renders variant-id]
      "video-job-result:v0" ($ preview-video-render {:variant-id variant-id})
      nil)))

(defn- gallery-preview-panel []
  (let [variant-id @(rf/subscribe [:variants-preview.variants/current-variant-id])]
    [:f> preview-variant variant-id]))

(defn- side-by-side-preview-panel []
  (let [ordered-selected-variant-ids @(rf/subscribe [:variants-preview.variants/ordered-selected-variant-ids])]
    [:> Stack {:direction "row" :flex-wrap "wrap" :gap 3}
     (for [variant-id ordered-selected-variant-ids]
       ^{:key variant-id}
       [:f> preview-variant variant-id])]))

(defui artwork-and-message [{:keys [artwork title description sx]}]
  ($ Stack
     {:direction "column"
      :alignItems "center"
      :justifyContent "center"
      :spacing 2
      :sx (spread-obj #js {:py 2
                           :flex 1}
                      sx)}
     artwork
     ($ Typography
        {:variant "h2"}
        title)
     description))

(defui component-empty-state [{:keys [sx message title]}]
  ($ artwork-and-message
     {:sx sx
      :artwork ($ Error {:width 240 :height 240})
      :title title
      :description ($ Stack
                      {:direction "column"
                       :sx #js {:textAlign "center"
                                :alignItems "center"
                                :justifyContent "center"}}
                      ($ Typography message))}))

(defn empty-state-preview [variant-id]
  (let [renders @(rf/subscribe [:variants-preview.variants/renders variant-id])
        render (first (filter #(= variant-id (:variant-id %)) renders))
        content-id @(rf/subscribe [:variants-preview.variants/content-id variant-id])
        {:keys [width height]} (-> render :job-result)
        auth-status @(rf/subscribe [:resource.auth/init-status])
        approved? @(rf/subscribe [:variants-preview.variants/approval-status variant-id])
        published? @(rf/subscribe [:variants-preview.variants/published-status variant-id])]
    [:> Stack {:spacing 1 :width "min-content"}
     [:> Typography {:font-weight "600" :sx {:word-break "break-all"}} content-id]
     [:> Stack {:direction "row" :align-items "center" :spacing 1
                :sx        {:justify-content "space-between"}}
      [:> Stack {:direction "row" :align-items "center" :spacing 1}
       [:> Chip {:label (str width "x" height)}]]]
     (when (not= auth-status :initializing)
       (if (and (not= auth-status :success) (not published?))
         ($ login-button)
         ($ approval-button
            {:variant-id variant-id
             :approved? approved?
             :published? published?})))
     ($ component-empty-state
        {:sx #js {:backgroundColor "grey.90"
                  :width   340
                  :height  280
                  :flex    0}
         :title   "Strategy preview is unavailable"
         :message "The variant related to the template dimensions is not published."})]))

(defn- strategy-preview-panel []
  (let [variant-id @(rf/subscribe [:variants-preview.variants/current-variant-id])
        targeting-values @(rf/subscribe [:variants-preview.variants/targeting-values variant-id])
        ordered-selected-variant-ids @(rf/subscribe [:variants-preview.variants/targeting-display-variants-ids targeting-values])
        no-variant-marked-as-default @(rf/subscribe [:variants-preview.variants/strategy-no-default-variant-display-message targeting-values])
        is-targeting-set? @(rf/subscribe [:variants-preview.variants/is-targeting-configuration-set?])
        display-not-approved-variants @(rf/subscribe [:variants-preview.variants/targeting-variants-not-approved targeting-values])]
    (if is-targeting-set?
      (if no-variant-marked-as-default
        ($ component-empty-state
           {:title "There is no variant marked as default"
            :message "In this strategy scenario the result should show a default, you have to mark a variant as default to show the result of the strategy."})
        (when (or (seq display-not-approved-variants)
                  (seq ordered-selected-variant-ids))
          [:> Stack {:direction "row"
                     :flex-wrap "wrap"
                     :gap 3}
           (when (seq ordered-selected-variant-ids)
             (for [variant-id ordered-selected-variant-ids]
               ^{:key variant-id}
               [:f> preview-variant variant-id]))
           (when (seq display-not-approved-variants)
             (for [variant-id display-not-approved-variants]
               ^{:key variant-id}
               (empty-state-preview variant-id)))]))
      ($ component-empty-state
         {:height  280
          :width   340
          :title   "Strategy preview is unavailable"
          :message "No targeting details found for the variants, please import targeting from your data sheet to start previewing strategy"}))))

(defui variants-settings [{:keys [mobile?]}]
  (let [adset-channel (use-subscribe [:resource.adset-preview/adset-channel])
        auto-play (use-subscribe [:variants-preview.core/auto-play])
        auto-mute (use-subscribe [:variants-preview.core/auto-mute])
        zoom-level (use-subscribe [:variants-preview.core/zoom-level])]
    ($ Stack
       {:direction "row"
        :justifyContent "space-between"
        :flexWrap "wrap"
        :gap 2}
       ($ Stack
          {:direction "row"
           :alignItems "center"
           :spacing 1}
          (when-not mobile?
            ($ Typography {:component "label" :fontWeight "600"} "Settings:"))
          ($ Button
             {:start-icon ($ Icon "menu")
              :disabled (use-subscribe [:variants-preview.core/value :sidebar-visible])
              :onClick #(rf/dispatch [:variants-preview.core/set-sidebar-visible true])
              :variant "text"
              :sx #js {:whiteSpace "nowrap"}}
             "Variant details"))

       (when (not= adset-channel "display")
         ($ Stack
            {:direction "row"
             :alignItems "center"
             :spacing 1
             :flexGrow 1}
            ($ checkbox
               {:label "Auto-play previews"
                :on-change #(rf/dispatch [:variants-preview.core/set-auto-play %])
                :value auto-play})
            ($ checkbox
               {:label "Auto-mute previews"
                :on-change #(rf/dispatch [:variants-preview.core/set-auto-mute %])
                :value auto-mute})))

       ;; Zoom controls are hidden for display adsets, for now.
       (let [video-width (int (use-subscribe [:variants-preview.core/video-width]))
             video-height (int (use-subscribe [:variants-preview.core/video-height]))]
         (when (and (not= adset-channel "display") (not mobile?))
           ($ Stack {:direction "row" :gap 2}
              ($ form-field
                 {:label "Width:"
                  :direction "row"
                  :alignItems "center"}
                 ($ input
                    {:value video-width
                     :onChange #(rf/dispatch [:variants-preview.core/set-video-width (-> % .-target .-value)])
                     :sx #js {:width "10rem"}}))

              ($ form-field
                 {:label "Height:"
                  :direction "row"
                  :alignItems "center"}
                 ($ input
                    {:value video-height
                     :onChange #(rf/dispatch [:variants-preview.core/set-video-height (-> % .-target .-value)])
                     :sx #js {:width "10rem"}}))

              ($ form-field
                 {:label "Zoom:"
                  :direction "row"
                  :alignItems "center"}
                 (r/as-element
                  [dropdown {:value zoom-level
                             :on-change #(rf/dispatch [:variants-preview.core/set-zoom-level %])
                             :options [{:label "25%"
                                        :value 25}
                                       {:label "50%"
                                        :value 50}
                                       {:label "75%"
                                        :value 75}
                                       {:label "100%"
                                        :value 100}]
                             :sx {:width "10rem"}}]))))))))

(defn- variant-based-adset-panel
  [mobile?]
  (let [display-mode @(rf/subscribe [:variants-preview.core/display-mode])]
    [:> Stack {:p 3 :spacing 2 :flex-grow 1 :sx {:overflow-y "auto"}}
     ($ variants-settings {:mobile? mobile?})
     ($ Typography {:variant "h2"} "Variant previews")
     (case display-mode
       :gallery [gallery-preview-panel]
       :side-by-side [side-by-side-preview-panel]
       :strategy [strategy-preview-panel]
       [gallery-preview-panel])]))

(defn variants-preview-panel
  "Hiccup for rendering the adset preview page as panel"
  [mobile?]
  ;; Data loading effects
  (let [display-mode @(rf/subscribe [:variants-preview.core/display-mode])
        {:keys [cursor]} @(rf/subscribe [:context/select-keys [:cursor]])]
    (react/useEffect (fn []
                       (when (= display-mode :gallery)
                         (rf/dispatch [:variants-preview.variants/reset-targeting-drop-down-choices])
                         (rf/dispatch [:resource.content-variants/get-adjacent cursor]))
                       js/undefined)
                     #js [display-mode cursor])
    (react/useEffect (fn []
                       (when (= display-mode :strategy)
                         (rf/dispatch [:resource.content-variants/get-adjacent cursor])
                         (rf/dispatch [:resource.content-variants/get-variants-for-preview])
                         (rf/dispatch [:variants-preview.variants-status/set-filtering-variant-status ["draft" "approved" "published"]]))
                       js/undefined)
                     #js [display-mode cursor])
    (react/useEffect (fn []
                       (when (= display-mode :side-by-side)
                         (rf/dispatch [:variants-preview.variants/reset-targeting-drop-down-choices])
                         (rf/dispatch [:resource.content-variants/get-variants-for-preview]))
                       js/undefined)
                     #js [display-mode])
    (react/useEffect (fn []
                       (rf/dispatch [:variants-preview.variants/init-polling])
                       js/undefined)
                     #js []))

  [:> Stack {:direction "row" :flex-grow 1}
   [sidebar mobile?]
   [variant-based-adset-panel mobile?]])
